/**
 * Wishlist
 * Simple localStorage-backed wishlist used by the product card heart button,
 * the header wishlist icon, and the mobile bottom nav wishlist icon.
 */
(function () {
  var STORAGE_KEY = 'spoilt_wishlist_items';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode, etc). Fail silently. */
    }
  }

  function isWishlisted(id) {
    if (!id) return false;
    var list = getWishlist();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return true;
    }
    return false;
  }

  function toggle(id, handle) {
    if (!id) return false;
    var list = getWishlist();
    var existingIndex = -1;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) {
        existingIndex = i;
        break;
      }
    }

    var nowActive;
    if (existingIndex > -1) {
      list.splice(existingIndex, 1);
      nowActive = false;
    } else {
      list.push({ id: id, handle: handle || '' });
      nowActive = true;
    }

    saveWishlist(list);
    updateCountUI();
    window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: list.length } }));
    return nowActive;
  }

  function updateCountUI() {
    var count = getWishlist().length;
    var countEls = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < countEls.length; i++) {
      countEls[i].textContent = count;
    }
    var bubbleEls = document.querySelectorAll('[data-wishlist-count-bubble]');
    for (var j = 0; j < bubbleEls.length; j++) {
      bubbleEls[j].hidden = count === 0;
    }
  }

  function refreshButtonStates() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var id = btn.getAttribute('data-product-id');
      var active = isWishlisted(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function getDrawer() {
    return document.querySelector('[data-wishlist-drawer]');
  }

  function renderDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    var listEl = drawer.querySelector('[data-wishlist-items]');
    var emptyEl = drawer.querySelector('[data-wishlist-empty]');
    if (!listEl) return;

    var items = getWishlist();

    if (items.length === 0) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    listEl.innerHTML = '<div class="wishlist-drawer__loading">Loading&hellip;</div>';

    var fetches = items.map(function (item) {
      if (!item.handle) return Promise.resolve(null);
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(fetches).then(function (products) {
      // Guard against the drawer having been closed/reopened while fetching.
      var currentDrawer = getDrawer();
      if (!currentDrawer) return;
      var currentList = currentDrawer.querySelector('[data-wishlist-items]');
      if (!currentList) return;

      currentList.innerHTML = '';
      var renderedAny = false;

      products.forEach(function (product, index) {
        if (!product) return;
        renderedAny = true;
        var item = items[index];
        var image = product.featured_image || (product.images && product.images[0]) || '';
        var priceHtml = formatMoney(product.price);
        var variant = null;
        if (product.variants && product.variants.length) {
          for (var v = 0; v < product.variants.length; v++) {
            if (product.variants[v].available) {
              variant = product.variants[v];
              break;
            }
          }
          if (!variant) variant = product.variants[0];
        }
        var variantId = variant ? variant.id : '';
        var canAdd = variant && variant.available;

        var row = document.createElement('div');
        row.className = 'wishlist-drawer__item';
        row.innerHTML =
          '<a href="/products/' + product.handle + '" class="wishlist-drawer__item-image">' +
          '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="64" height="64">' +
          '</a>' +
          '<div class="wishlist-drawer__item-info">' +
          '<a href="/products/' + product.handle + '" class="wishlist-drawer__item-title">' + escapeHtml(product.title) + '</a>' +
          '<div class="wishlist-drawer__item-price">' + priceHtml + '</div>' +
          (canAdd
            ? '<button type="button" class="button button--small wishlist-drawer__item-add" data-wishlist-add-to-cart="' + variantId + '">Add to cart</button>'
            : '<span class="wishlist-drawer__item-price" style="opacity:.6;">Sold out</span>') +
          '</div>' +
          '<button type="button" class="wishlist-drawer__item-remove" data-wishlist-remove="' + item.id + '" aria-label="Remove from wishlist">&times;</button>';
        currentList.appendChild(row);
      });

      if (!renderedAny) {
        currentList.innerHTML = '';
        var currentEmpty = currentDrawer.querySelector('[data-wishlist-empty]');
        if (currentEmpty) currentEmpty.hidden = false;
      }
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme_money_format) {
      try {
        return window.Shopify.formatMoney(cents, window.theme_money_format);
      } catch (e) {
        /* fall through to default formatting */
      }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-mobile-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-mobile-cart-badge]').forEach(function (el) {
          el.hidden = cart.item_count === 0;
        });
        var desktopCountSpan = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
        if (desktopCountSpan) {
          desktopCountSpan.textContent = cart.item_count;
        }
      })
      .catch(function () {
        /* non-critical: badges just won't refresh this time */
      });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    renderDrawer();
    drawer.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('active');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      var id = toggleBtn.getAttribute('data-product-id');
      var handle = toggleBtn.getAttribute('data-product-handle');
      toggle(id, handle);
      refreshButtonStates();
      return;
    }

    var openBtn = e.target.closest('[data-wishlist-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var closeBtn = e.target.closest('[data-wishlist-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      var removeId = removeBtn.getAttribute('data-wishlist-remove');
      toggle(removeId, null);
      refreshButtonStates();
      renderDrawer();
      return;
    }

    var addBtn = e.target.closest('[data-wishlist-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-wishlist-add-to-cart');
      if (!variantId || addBtn.disabled) return;
      var originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data && data.description ? data.description : 'Could not add to cart');
            return data;
          });
        })
        .then(function () {
          addBtn.textContent = 'Added';
          refreshCartCount();
          setTimeout(function () {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          addBtn.textContent = 'Try again';
          addBtn.disabled = false;
          setTimeout(function () {
            addBtn.textContent = originalText;
          }, 1500);
        });
      return;
    }

    var overlay = e.target.closest('[data-wishlist-overlay]');
    if (overlay) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCountUI();
    refreshButtonStates();
  });

  window.Wishlist = {
    getWishlist: getWishlist,
    toggle: toggle,
    isWishlisted: isWishlisted,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
  };
})();
